module.exports = __webpack_public_path__ + "static/img/coo_close.bdf3e150.png";